// extracted by mini-css-extract-plugin
export default {"titleDiv":"RechargeRecord_titleDiv__csAKB","title0":"RechargeRecord_title0__RZcu-","title1":"RechargeRecord_title1__bBXwU"};